import { connect } from 'react-redux';
import MessageListComponent from '../components/message_list';

function mapStateToProps(state) {
  const hasMultipleParticipants = state.activeConversation.participants && state.activeConversation.participants.length > 1;

  return {
    messages: state.activeConversation.messages,
    loading: state.activeConversation.loading,
    error: state.activeConversation.error,
    hasConversations: state.conversations.edges.length > 0,
    hasActiveConversation: state.activeConversation.hasOwnProperty('id'),
    newConversation: state.conversationCreator.visible,
    messageCreatorHeight: state.messageCreator.height,
    currentUser: state.currentUser,
    conversationDetailsVisible: state.conversationDetails.visible,
    searchResultsPresent: state.search.userIds.length > 0,
    isGroupConversation: !!hasMultipleParticipants
  };
}

const MessageListContainer = connect(
  mapStateToProps,
  {}
)(MessageListComponent);

export default MessageListContainer;
